module.exports = __webpack_public_path__ + "static/media/1B.56415728.png";